import { DragEvent, useEffect, useRef } from "react";
import { DizilimModel } from "../../../models/businessModels/DizilimModel";
import { HesapBilgiVeKullaniciModel } from "../../../models/businessModels/HesapBilgiVeKullaniciModel";
import { SesGrupModel } from "../../../models/businessModels/SesGrupModel";
import appColors from "../../../app/appColors";
import { DizilimHesapModel } from "../../../models/businessModels/DizilimHesapModel";
import GenelDurumHelper from "../../../helpers/GenelDurumHelper";
import { BusinessHelper } from "../../../helpers/BusinessHelper";
import DizilimKoristDisplayer, { DizilimKoristDragData } from "./DizilimKoristDisplayer";
import JsonHelper from "../../../library/helpers/JsonHelper";

const dizilimMainUnitInPixels = BusinessHelper.KonserDizilim.DizilimMainUnitInPixels;

interface IDizilimDiplayerProps {
    dizilim: DizilimModel | null,
    hesaplar: { hesap: HesapBilgiVeKullaniciModel, sesGrup: SesGrupModel }[],
    dizilimChanged: (dizilimModel: DizilimModel) => void,
    readonly: boolean,
    genelDurumHelper: GenelDurumHelper
}

function DizilimDisplayer(props: IDizilimDiplayerProps) {
    const { dizilim, hesaplar, dizilimChanged, readonly, genelDurumHelper } = props;

    const canvasRef = useRef<HTMLCanvasElement>(null);
    const parentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // if (!canvasRef.current) return;

        // const observer = new ResizeObserver(entries => {
        //     //const entry = entries[0];
        //     //const { width, height } = entry.contentRect;
        //     myRender();
        // });

        // observer.observe(canvasRef.current);

        // return () => observer.disconnect();
        myRender();
    }, [])

    function handleOnDrop(e: DragEvent<HTMLDivElement>): void {
        if (readonly) return;

        e.preventDefault();

        const serializedData = e.dataTransfer.getData("text/plain");
        if (!serializedData) return;

        const data = JsonHelper.parse<DizilimKoristDragData>(serializedData)!;

        dizilimHesapCoordinateChanged(data.id, e.clientX - data.x, e.clientY - data.y);
    }

    function dizilimHesapCoordinateChanged(hesapId: string, clientX: number, clientY: number): void {
        const parentRect = parentRef.current!.getBoundingClientRect();

        const x = clientX - parentRect.left;
        const y = clientY - parentRect.top;

        const yeniDizilimHesap = JsonHelper.deepCopy(dizilim!.dizilimHesapModelList.single(e => e.hesapId === hesapId));
        yeniDizilimHesap.locationX = Math.round((x) / dizilimMainUnitInPixels);
        yeniDizilimHesap.locationY = Math.round((y) / dizilimMainUnitInPixels);

        dizilimHesapChanged(yeniDizilimHesap)
    }

    function dizilimHesapChanged(dizilimHesap: DizilimHesapModel): void {
        const eskiler = dizilim!.dizilimHesapModelList.where(e => e.hesapId !== dizilimHesap.hesapId);
        const result = {
            ...dizilim!,
            dizilimHesapModelList: [
                ...eskiler,
                dizilimHesap
            ]
        }

        dizilimChanged(result);
    }

    function myRender() {
        const ctx = canvasRef.current?.getContext("2d");
        if (!ctx) return;

        const myCanvas = canvasRef.current!;

        ctx.clearRect(0, 0, myCanvas.width, myCanvas.height);

        const canvasW = myCanvas.clientWidth;
        const canvasH = myCanvas.clientHeight;

        // If it's resolution does not match, change it
        if (myCanvas.width !== canvasW || myCanvas.height !== canvasH) {
            myCanvas.width = canvasW;
            myCanvas.height = canvasH;
        }

        ctx.fillStyle = appColors.GRAY_LIGHT5;
        ctx.fillRect(0, 0, canvasW, canvasH);

        ctx.lineWidth = 1;
        ctx.fillStyle = appColors.GRAY_LIGHT4;
        for (let x = dizilimMainUnitInPixels; x < canvasW; x += dizilimMainUnitInPixels) {
            ctx.fillRect(x, 0, 1, canvasH);
        }

        for (let y = dizilimMainUnitInPixels; y < canvasH; y += dizilimMainUnitInPixels) {
            ctx.fillRect(0, y, canvasW, 1);
        }

        ctx.fillStyle = appColors.GRAY_LIGHT3;
        for (let x = dizilimMainUnitInPixels; x < canvasW; x += dizilimMainUnitInPixels)
            for (let y = dizilimMainUnitInPixels; y < canvasH; y += dizilimMainUnitInPixels) {
                ctx.beginPath();
                ctx.ellipse(x, y, 2, 2, 0, 0, 2 * Math.PI)
                ctx.fill();
                ctx.closePath();
            }
    }

    myRender();
    window.requestAnimationFrame(() => { });

    return <div ref={parentRef} onDragOver={readonly ? undefined : ((e) => e.preventDefault())} onDrop={readonly ? undefined : handleOnDrop} style={{ height: "100%", width: "100%", minHeight: "350px", minWidth: "250px", flex: 1, overflow: "hidden", position: "relative", }}>
        <canvas
            ref={canvasRef}
            style={{
                touchAction: "none",
                width: "100%",
                left: 0,
                top: 0,
                height: "100%",
                position: "relative",
                zIndex: 10,
            }} />
        {dizilim?.dizilimHesapModelList.map(item => <DizilimKoristDisplayer readonly={readonly} key={item.hesapId} hesapDizilim={item} hesaplar={hesaplar} genelDurumHelper={genelDurumHelper} />)}
    </div>
}

export default DizilimDisplayer;